import { Spacer, Text } from "@hackthenorth/north";
import { Button, Link } from "north.js";
import React from "react";
import styled from "styled-components";

import { PageWrapper } from "src/shared/components";
import {
  Permission,
  useHackerContext,
  usePermissionsContext,
  useUserContext,
} from "src/shared/contexts";
import { HackerStage } from "src/shared/contexts/HackerContext/types";
import { useRsvpFlow } from "src/shared/hooks";

import Withdraw from "./shared/withdraw";
import StatusComponent from "./status";
import { canWithdrawFromStage } from "./util";

const RSVPHomePageWrapper = styled(PageWrapper)`
  max-width: 100%;
`;

const RsvpHome = () => {
  const { isHacker } = useRsvpFlow();
  const {
    navigateNext,
    stage,
    claimFound,
    error: claimError,
  } = useHackerContext();
  const { error: userError, signInAgain } = useUserContext();
  const { hasPermission } = usePermissionsContext();
  const canStartRsvp =
    hasPermission(Permission.RSVP_EDIT) && hasPermission(Permission.RSVP_FORM);

  if (
    claimFound === false ||
    !stage ||
    !Object.values(HackerStage).includes(stage)
  ) {
    const lookupFailed = !!(claimError || userError);
    return (
      <RSVPHomePageWrapper>
        <Text mods="h2 heading">
          {lookupFailed
            ? "We couldn’t load your RSVP"
            : "Your RSVP is not ready yet"}
        </Text>
        <Spacer height={16} />
        <Text>
          {lookupFailed
            ? "Try signing in again to reload your account."
            : "We couldn’t find an active RSVP for your account. If you recently received an invitation, try signing in again with the email address it was sent to."}{" "}
          If you still need help, contact{" "}
          <Link href="mailto:hello@hackthenorth.com">
            hello@hackthenorth.com
          </Link>
          .
        </Text>
        <Spacer height={24} />
        <Button color="primary" size="lg" onClick={signInAgain}>
          Sign in again
        </Button>
      </RSVPHomePageWrapper>
    );
  }

  const hasRsvped =
    stage === HackerStage.CONFIRMED || stage === HackerStage.CHECKED_IN;
  const canWithdraw = canWithdrawFromStage(stage);

  return (
    <RSVPHomePageWrapper>
      {isHacker ||
      hasRsvped ||
      (stage !== HackerStage.ACCEPTED &&
        stage !== HackerStage.AUTO_ACCEPTED) ? (
        <StatusComponent />
      ) : (
        <>
          <Text mods="h2 heading">RSVP to Hack the North 2026</Text>
          <Spacer height={16} />
          <Text>
            Complete your attendee information and waiver before arriving at the
            event.
          </Text>
          <Spacer height={32} />
          {canStartRsvp ? (
            <Button color="primary" size="lg" onClick={navigateNext}>
              Start RSVP
            </Button>
          ) : (
            <Text>
              The RSVP form is currently closed. You can still view your RSVP
              status here.
            </Text>
          )}
          {canWithdraw && (
            <>
              <Spacer height={32} />
              <Withdraw />
            </>
          )}
        </>
      )}
    </RSVPHomePageWrapper>
  );
};

export default RsvpHome;
